import { reduce } from 'lodash';

import { ProvisioningEnum, RolloutEnum } from '@lib/resources/types';

import { Permissions } from 'selectors/selectPermissions';

import { hasAccessToProduct } from './hasAccessToProduct';

// Mapping between pathnames and provisioning/rollout
const PATHNAME_MAPPING: Partial<Record<ProvisioningEnum | RolloutEnum, RegExp>> = {
  // matches for provisioning
  'outbound-referral': /outbound-referral/i,
  branding: /styling|branding/i,
  broadcast: /broadcast/i,
  lumabot: /^lumabot$/i,
  chat: /secureChat|hub|collaboration|chat/i,
  feedback: /feedback/i,
  followup: /followup|customAction/i,
  insurance: /\binsurance\b/i,
  'intake-form': /intake-form|formBuilder|forms/i,
  'insurance-verification': /insurance-verification|copay|patientbilling|financial|luma-pay|lumapay/i,
  'prequal-form': /prequal-form|formBuilder|forms/i,
  'luma-pay': /copay|patientbilling|financial|luma-pay|lumapay/i,
  recall: /recall/i,
  referral: /referral/i,
  reminder: /reminder/i,
  // this is a rollout but it needs preceed scheduler provisioning because it returns the scheduler
  // key even using /bscheduler/b|(scheduler), try to use ^scheduler$ can make it fails on places that send reschedule for example
  'advanced-scheduler-options': /advanced-scheduler-options/i,
  scheduler: /scheduler/i,
  waitlist: /waitlist|offers/i,
  // matches for rollouts
  journey: /journey/i,
  labs: /labs/i,
  upload: /upload/i,
  telehealth: /telehealth/i,
  'waiting-room': /waiting-room/i,
  ccda: /^ccda$/i, // exact match since mongoIDs can have ccda in them
  'settings-v2': /settings-v2/i,
  'old-broadcasts': /old-broadcasts/i,
  'messaging-activity': /^messaging-activity$/i,
  'patient-merge': /^patient-merge$/i,
  'waitlists-tags': /^waitlists-tags$/i,
  form: /^form$/i,
  reports: /^reports$/i,
  formBuilder: /^formBuilder$/i,
};

export function hasAccessToPathname(permissions?: Permissions, pathname?: string): boolean {
  const keysArray = reduce(
    PATHNAME_MAPPING,
    (result: string[], regexp: any, key) => {
      if (regexp && pathname && regexp.test(pathname)) result.push(key);
      return result;
    },
    [],
  );
  return hasAccessToProduct(permissions, keysArray as ProvisioningEnum[] | RolloutEnum[]);
}
